import { lazy, StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { ChallengeApp } from './challenge/ChallengeApp.tsx';
import { Home } from './Home.tsx';
import { SimApp } from './simulador/SimApp.tsx';
import { isSimPath } from './simulador/router.ts';
import './index.css';

// The minigames load apart: their drawing code is only fetched at /juegos
const GamesApp = lazy(() => import('./juegos/GamesApp.tsx').then((m) => ({ default: m.GamesApp })));

// The home page (/), the challenge (/reto/…), the simulator (/simulador/…) and the chat
// (/pregunta) share the bundle; a link between them reloads
const isChallenge = location.pathname === '/reto' || location.pathname.startsWith('/reto/');

const isSim = isSimPath(location.pathname);

const isGames = /^\/juegos(\/|$)/.test(location.pathname);

const isChat = /^\/pregunta\/?$/.test(location.pathname);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {isGames ? (
      <Suspense fallback={null}>
        <GamesApp />
      </Suspense>
    ) : isSim ? (
      <SimApp />
    ) : isChallenge ? (
      <ChallengeApp />
    ) : isChat ? (
      <App />
    ) : (
      <Home />
    )}
  </StrictMode>,
);
